import { memo, useEffect, useState, useCallback } from "react";
import Form from "../../components/Form.js";
import useSelectStyles from "../../components/styles/Select.js";
import { useSnackbar } from "../../utils/index.js";
import Spinner from "../../components/Spinner.js";
import AreYouSurePopup from "../../components/popups/AreYouSurePopup.js";
import { Box, Typography } from "@mui/material";
import { getOwners, transportOwner } from "../../api/index.js";

const OwnerTransfer = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [fetchedOwners, setFetchedOwners] = useState([]);
    const [ownersDropdownValues, setOwnersDropdownValues] = useState([]);
    const [selectedOldOwner, setSelectedOldOwner] = useState();
    const [selectedOldOwnerValue, setSelectedOldOwnerValue] = useState();
    const [selectedNewOwner, setSelectedNewOwner] = useState();
    const [selectedNewOwnerValue, setSelectedNewOwnerValue] = useState();
    const [selectedTransferDate, setSelectedTransferDate] = useState();
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [selectedValues, setSelectedValues] = useState([]);

    const classes = useSelectStyles();
    const { success, error } = useSnackbar();

    const fetchData = useCallback(
        async () => {
            setIsLoading(true);
            try {
                const { owners } = await getOwners();
                setFetchedOwners(owners);
                setOwnersDropdownValues(owners.map((owner) => ({
                    value: `${owner?.lastName} ${owner?.firstName} - ${owner?.code}`,
                    text: `${owner?.lastName} ${owner?.firstName} - ${owner?.code}`
                })));

            } catch (err) {
                error(err)
            }
            setIsLoading(false);
        }
    )

    useEffect(() => {
        fetchData();
    }, []);

    const transferFormConent = [
        {
            customType: "dropdown",
            id: "oldOwner",
            items: ownersDropdownValues,
            placeholder: "Εκτροφή",
            required: true,
            value: selectedValues?.oldOwner || null,
        },
        {
            customType: "dropdown",
            id: "newOwner",
            items: ownersDropdownValues,
            placeholder: "Νέα Εκτροφή",
            required: true,
            value: selectedValues?.newOwner || null,
        },
        {
            customType: "date-picker",
            id: "transferDate",
            type: "desktop",
            label: "Ημ/νία Μεταβίβασης",
            width: "595px",
            background: "third",
            required: true,
            value: selectedValues?.transferDate || null,
        },
        {
            customType: "button",
            id: "submit",
            type: "submit",
            text: "Υποβολή"
        },
    ]

    const handleFormSubmit = (values) => {
        setSelectedValues(values)
        setSelectedOldOwnerValue(values.oldOwner);
        setSelectedNewOwner(fetchedOwners.find((owner) => `${owner?.lastName} ${owner?.firstName} - ${owner?.code}` === values.newOwner));
        setSelectedNewOwnerValue(values.newOwner);
        setSelectedOldOwner(fetchedOwners.find((owner) => `${owner?.lastName} ${owner?.firstName} - ${owner?.code}` === values.oldOwner));
        setSelectedTransferDate(values.transferDate);
        setIsPopupOpen(true);
    }

    const handleTransport = async () => {
        setIsLoading(true);
        console.log(selectedOldOwner._id, selectedNewOwner._id, selectedTransferDate)
        const valuesToSend = {
            oldOwner: selectedOldOwner._id,
            newOwner: selectedNewOwner._id,
            transferDate: selectedTransferDate,
        }
        const { success: scs, message } = await transportOwner(valuesToSend);
        if (scs) {
            success(message);
        } else {
            error(message);
        }
        setIsLoading(false);
    }

    return (
        <>
            <Spinner open={isLoading} />
            <AreYouSurePopup
                width={"900px"}
                isOpen={isPopupOpen}
                title="Μεταβίβαση Εκτροφής"
                titleColor="black"
                onClose={() => window.location.reload()}
                innerText={`Είστε σίγουροι ότι θέλετε μεταβιβάσετε την Εκτροφή "${selectedOldOwnerValue}" στην "${selectedNewOwnerValue}";`}
                declineText="Πίσω"
                onDecline={() => window.location.reload()}
                acceptText="Ναι, Μεταβίβαση Εκτροφής"
                onAccept={() => handleTransport()}
            />
            <Box className={classes.outerBox}>
                <Box container flexDirection="column" className={classes.innerBox}>
                    <Typography variant="h5" sx={{ margin: "1rem" }}>
                        Μεταβίβαση Εκτροφής
                    </Typography>
                    <Form content={transferFormConent} onSubmit={handleFormSubmit} />
                </Box>
            </Box>
        </>
    )
}

export default memo(OwnerTransfer)